export default "__VITE_ASSET__cl_XI5EF__"